module.exports = __webpack_public_path__ + "static/media/0013-Erkundigen_mV_ID_7.cd7d070b.mp3";